import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export type EmptyStateProps = {
  children: ReactNode;
};

export function EmptyState({ children }: EmptyStateProps) {
  return <Box sx={{ p: 3, minWidth: 0, textAlign: 'center' }}><Typography component="div" variant="body2" color="text.secondary" sx={{ overflowWrap: 'anywhere' }}>{children}</Typography></Box>;
}
